import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/mail`;
const token = localStorage.getItem("token");

// Fonction pour envoyer un mail de rappel
export const sendReminderMail = async ({ email, subject, text }) => {
  try {
    const response = await axios.post(
      `${apiUrl}/sendReminder`,
      { email, subject, text },
      {
        headers: {
          Authorization: `Bearer ${token}`, // facultatif si ton middleware le nécessite
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'envoi du mail de rappel :", error);
    throw error;
  }
};

// Fonction pour envoyer un mail pour le formulaire de contact au club
export const sendContactFormMail = async (formData) => {
  try {
    await axios.post(`${apiUrl}/sendContactForm`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Email envoyé au club avec succès");
  } catch (error) {
    console.log("formData:", formData);
    console.error("Erreur lors de l'envoi de l'email de contact:", error);
  }
};